var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInProgresssmall({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 -0.5 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 0a5 5 0 100 10 5 5 0 000-10zm0 9.091a4.09 4.09 0 110-8.181 4.09 4.09 0 010 8.181z",
    fill: "url(#in_progress_small_svg__paint0_linear_1784:123387)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 8a3 3 0 110-6v6z",
    fill: "url(#in_progress_small_svg__paint1_linear_1784:123387)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "in_progress_small_svg__paint0_linear_1784:123387",
    x1: -4.25,
    y1: 5,
    x2: 5.75,
    y2: 15.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E72828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "in_progress_small_svg__paint1_linear_1784:123387",
    x1: 2.75,
    y1: 2,
    x2: 8.75,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F43B3B"
  })))));
}

export default SvgInProgresssmall;